import { inject } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { map } from "rxjs";
import { entityActions } from "src/app/state/entities/entity.actions";
import { EntityType } from "src/app/state/entities/entity.model";
import { InstanceService } from "./instance.service";
import { InitType } from "../cyanprints/blueprint";

export const newInstance = createEffect(
  (
    actions$ = inject(Actions),
    instanceService = inject(InstanceService),
  ) => {
    return actions$.pipe(
      ofType(entityActions.netFound, entityActions.found, entityActions.netCreated, entityActions.created),
      map(async (action) => {
        const entity = action.entity;
        let initType = InitType.Found
        if (action.type === entityActions.netFound.type) {
          initType = InitType.Found
        }
        if (action.type === entityActions.netCreated.type) {
          initType = InitType.Created
        }
        instanceService.instance({
          entity, initType
        })
      }),
    );
  },
  { functional: true, dispatch: false },
);

export const moveInstance = createEffect(
  (
    actions$ = inject(Actions),
    instanceService = inject(InstanceService),
  ) => {
    return actions$.pipe(
      ofType(entityActions.netMoved),
      map((action) => {
        instanceService.moveInstance({
          newPos: action.newPos,
          oldPos: action.oldPos,
          instanceId: action.entityId
        })
      }),
    );
  },
  { functional: true, dispatch: false },
);

export const removeInstance = createEffect(
    (
        actions$ = inject(Actions),
        instanceService = inject(InstanceService),
    ) => {
        return actions$.pipe(
            ofType(entityActions.netDestroyed),
            map(async (action) => {
                const entityId = action.id;
                instanceService.removeInstance(entityId)
            }),
        );
    },
    { functional: true, dispatch: false },
);
